import { render } from "./EmployeeInfo.vue?vue&type=template&id=83547b20&scoped=true"
import script from "./EmployeeInfo.vue?vue&type=script&lang=js"
export * from "./EmployeeInfo.vue?vue&type=script&lang=js"

import "./EmployeeInfo.vue?vue&type=style&index=0&id=83547b20&scoped=true&lang=css"

import exportComponent from "/var/www/halisclock/releases/44/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83547b20"]])

export default __exports__